import { constantsActive } from 'utils/constants/constants'

export default class ObjectJobtitles {
	
	static defaults = {
		active: constantsActive.YES,
	}
}
